import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=2a151111&scoped=true&"
import script from "./SelectArea.vue?vue&type=script&lang=js&"
export * from "./SelectArea.vue?vue&type=script&lang=js&"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=2a151111&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a151111",
  null
  
)

export default component.exports